module.exports = __webpack_public_path__ + "img/header-diamondJewelry050Carat.deb7408.jpg";